import Layout from '../views/layout/App.vue'
export default {
  path: '/setting_manage',
  name: 'settingManage',
  meta: {
    title: '设置管理',
    keepAlive: false
  },
  component: Layout,
  redirect: '/setting_manage/base_info',
  children: [
    {
      path: 'base_info',
      name: 'baseInfo',
      meta: {
        title: '基本信息',
        keepAlive: true
      },
      component: resolve => require(['@/views/settingManage/baseInfo/Index.vue'], resolve),
    },
    {
      path: 'applet',
      name: 'applet',
      meta: {
        title: '学员学习入口',
        keepAlive: true
      },
      component: resolve => require(['@/views/settingManage/applet/Index.vue'], resolve),
    },
    {
      path: 'admin_setting',
      name: 'adminSetting',
      meta: {
        title: '管理员设置',
        keepAlive: true
      },
      component: resolve => require(['@/views/settingManage/adminSetting/Index.vue'], resolve),
    },
    {
      path: 'role_manage',
      name: 'roleManage',
      meta: {
        title: '角色设置',
        keepAlive: true
      },
      component: resolve => require(['@/views/settingManage/roleManage/Index.vue'], resolve),
    },
  ]
}
